import { cardImageSources, type GenericCharacter } from './types'

export const genericDrilo: GenericCharacter = {
  id: 'generic-drilo',
  enabled: true,
  featureFlag: 'drilo-character',
  order: 0,
  displayName: 'Drilo',
  icon: '🐊',
  imageSources: cardImageSources('generic-drilo'),
}
